import {
  BellIcon,
  ChatBubbleLeftIcon,
  LightBulbIcon,
  NewspaperIcon,
  PercentBadgeIcon
} from '@heroicons/react/24/solid'
import { FC, ReactNode } from 'react'

import {
  NotificationApiType,
  NotificationType
} from '@/api/models/notifications/lib/notifications.types'
import NotificationPassesIcon from '@/assets/svg/NotificationPassesIcon.svg'
import NotificationRequestIcon from '@/assets/svg/NotificationRequestIcon.svg'
import { BillsIcon } from '@/components/shared/icons'

type Props = {
  item: NotificationApiType
}

const iconClassName = 'h-32 w-32 text-grey-100 lg:h-24 lg:w-24 sm:h-20 sm:w-20'
const bellIcon = <BellIcon className={iconClassName} />

const config: Record<NotificationType, ReactNode> = {
  [NotificationType.Requests]: (
    <NotificationRequestIcon className={iconClassName} />
  ),
  [NotificationType.Passes]: (
    <NotificationPassesIcon className={iconClassName} />
  ),
  [NotificationType.Comments]: <ChatBubbleLeftIcon className={iconClassName} />,
  [NotificationType.Invoices]: (
    <BillsIcon className={iconClassName} solid dark />
  ),
  [NotificationType.InvoicesReminder]: <BillsIcon className={iconClassName} />,
  [NotificationType.InvoicesDebt]: <BillsIcon className={iconClassName} />,
  [NotificationType.News]: <NewspaperIcon className={iconClassName} />,
  [NotificationType.Proposals]: <PercentBadgeIcon className={iconClassName} />,
  [NotificationType.Service]: bellIcon,
  [NotificationType.Counters]: <LightBulbIcon className={iconClassName} />,
  [NotificationType.Basic]: bellIcon
}

const NotificationCardIcon: FC<Props> = ({ item }) => {
  return config[item.typeAlias]
}

export default NotificationCardIcon
